// extracted by mini-css-extract-plugin
export default {"container":"MasterData_container__fzINj","master":"MasterData_master__PjjO-","content":"MasterData_content__3ahL3"};